import {
  INavigationStats,
  IStripeRequirements,
  ISystem,
} from '../../ts/interface/system.interface';

/**
 * The banner across the top of the Billing page. It lives in its own module so
 * the precedence between the three warnings can be covered without pulling in
 * every billing tab.
 */
export function billingWarning({
  system,
  systemLoaded,
  navigationStats,
  stripeRequirements,
  isStripeAccountInfoLoading,
  transactionCount,
  rateCount,
}: {
  system: ISystem;
  systemLoaded: boolean;
  navigationStats: INavigationStats;
  stripeRequirements: IStripeRequirements | null | undefined;
  isStripeAccountInfoLoading: boolean;
  transactionCount: number | undefined;
  rateCount: number;
}): string | undefined {
  if (
    system &&
    system.billing &&
    system.payment_provider === 'stripe' &&
    !isStripeAccountInfoLoading &&
    stripeRequirements &&
    !stripeRequirements?.id &&
    systemLoaded
  ) {
    // stripe not verified
    return 'Please verify your settings account in /settings/billing';
  }

  if (Boolean(navigationStats.billing_warning)) {
    // no rates
    return navigationStats.billing_warning;
  }

  return !system.billing &&
    ((transactionCount ?? 0) !== 0 || rateCount !== 0) &&
    system.payment_provider !== 'qvo'
    ? 'Your billing is inactive, this data is historic. You will not be able to create new rate until billing is enabled.'
    : undefined;
}
